import { render } from "./ViewsProductsProduct.vue?vue&type=template&id=a4ac95aa"
import script from "./ViewsProductsProduct.vue?vue&type=script&lang=js"
export * from "./ViewsProductsProduct.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__